import { j as t } from "../../_virtual/jsx-runtime.js";
const x = ({
  width: o = 20,
  height: r = 20,
  viewBox: s = "0 0 20 20",
  fill: n = "currentColor",
  ...e
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: o,
    height: r,
    viewBox: s,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M17.5 12.5L12.5 17.4967L3.33518 17.5C2.87392 17.5 2.5 17.1292 2.5 16.6722V3.32783C2.5 2.87063 2.87079 2.5 3.32783 2.5H16.6722C17.1293 2.5 17.5 2.8798 17.5 3.33539V12.5ZM15.8333 4.16667H4.16667V15.8333H10.8333V11.6667C10.8333 11.2393 11.155 10.8871 11.5695 10.8389L11.6667 10.8333L15.8333 10.8325V4.16667ZM15.1425 12.4992L12.5 12.5V15.1408L15.1425 12.4992Z",
        fill: n
      }
    )
  }
);
export {
  x as default
};
